import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { DateRange } from "react-date-range";
import { format } from "date-fns";
import "react-date-range/dist/styles.css"; // 主樣式
import "react-date-range/dist/theme/default.css"; // 主題樣式

const CreateTrip = ({ refreshTrips }) => {
  const [tripName, setTripName] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [selectedCities, setSelectedCities] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [cityOptions, setCityOptions] = useState([]);
  const [tripNameEdited, setTripNameEdited] = useState(false); // 使用者是否自行輸入過名稱
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [range, setRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  const navigate = useNavigate();

  // useEffect(() => {
    // const fetchMatchingCities = async () => {
      // if (inputValue.length < 2) return;

      // try {
        // const res = await fetch(`${process.env.REACT_APP_API_URL}/trips/cities?query=${inputValue}`);
        // const data = await res.json();
        // const formatted = data
          // .filter(city => typeof city.name === "string" && typeof city.country_name === "string")
          // .map(city => ({
            // label: `${city.name}, ${city.country_name}`,
            // value: city.id.toString(),
            // country_name: city.country_name,
          // }));
        // setCityOptions(formatted);
      // } catch (error) {
        // console.error("City search error:", error);
      // }
    // };

    // const delayDebounce = setTimeout(fetchMatchingCities, 300);
    // return () => clearTimeout(delayDebounce);
  // }, [inputValue]);
  
	useEffect(() => {
	  const fetchGooglePlaces = async () => {
		if (inputValue.length < 2) return;
		try {
		  const res = await fetch(`${process.env.REACT_APP_API_URL}/trips/google_places?query=${inputValue}`);
		  const data = await res.json();
		  const formatted = data.map(place => ({
			label: `${place.name}, ${place.formatted_address}`,
			value: place.place_id,
			...place,
		  }));
		  setCityOptions(formatted);
		} catch (err) {
		  console.error("Google Places API error:", err);
		}
	  };

	  const timeout = setTimeout(fetchGooglePlaces, 300);
	  return () => clearTimeout(timeout);
	}, [inputValue]);  

  // useEffect(() => {
    // if (!tripNameEdited && selectedCities.length > 0) {
      // const uniqueCountries = [
        // ...new Set(selectedCities.map(city => city.country_name).filter(Boolean)),
      // ];
      // setTripName(`Trip to ${uniqueCountries.join(", ")}`);
    // }
  // }, [selectedCities, tripNameEdited]);
  
	// useEffect(() => {
	  // if (!tripNameEdited && selectedCities.length > 0) {
		// const cityNames = selectedCities.map(place => place.name);
		// setTripName(`Trip to ${cityNames.join(", ")}`);
	  // }
	// }, [selectedCities, tripNameEdited]);  

	useEffect(() => {
	  if (!tripNameEdited && selectedCities.length > 0) {
		const countries = selectedCities.map(place => {
		  const addressParts = place.formatted_address.split(",").map(part => part.trim());
		  return addressParts[addressParts.length - 1]; // 最後一項通常是國家
		});

		const uniqueCountries = [...new Set(countries)].filter(Boolean);
		setTripName(`Trip to ${uniqueCountries.join(", ")}`);
	  }
	}, [selectedCities, tripNameEdited]);

  // const createTrip = async () => {
    // if (!tripName || !startDate || !endDate) {
      // alert("Please fill in all fields！");
      // return;
    // }

    // if (new Date(startDate) > new Date(endDate)) {
      // alert("Start date cannot be later than the end date！");
      // return;
    // }

    // const token = localStorage.getItem("token");
    // if (!token) {
      // alert("Please Login");
      // return;
    // }

    // const response = await fetch(`${process.env.REACT_APP_API_URL}/trips/create_trip/`, {
      // method: "POST",
      // headers: {
        // "Content-Type": "application/json",
        // Authorization: `Bearer ${token}`,
      // },
      // body: JSON.stringify({
        // name: tripName,
        // start_date: startDate,
        // end_date: endDate,
        // cities: selectedCities.map(city => city.value),
      // }),
    // });

    // if (response.ok) {
      // alert("Trip created successfully！");
      // setTripName("");
      // setStartDate("");
      // setEndDate("");
      // setSelectedCities([]);
      // setTripNameEdited(false);

      // if (refreshTrips) refreshTrips();
      // navigate("/dashboard");
    // } else {
      // const errorData = await response.json();
      // alert("Failed to create trip：" + JSON.stringify(errorData));
    // }
  // };
  
	const createTrip = async () => {
	  if (!tripName || !startDate || !endDate) {
		alert("Please fill in all fields！");
		return;
	  }

	  const token = localStorage.getItem("token");
	  if (!token) {
		alert("Please Login");
		return;
	  }

	  const body = {
		name: tripName,
		start_date: startDate,
		end_date: endDate,
		places: selectedCities.map(place => ({
		  place_id: place.place_id,
		  name: place.name,
		  formatted_address: place.formatted_address,
		  lat: place.lat,
		  lng: place.lng,
		})),
	  };

	  const response = await fetch(`${process.env.REACT_APP_API_URL}/trips/create_trip/`, {
		method: "POST",
		headers: {
		  "Content-Type": "application/json",
		  Authorization: `Bearer ${token}`,
		},
		body: JSON.stringify(body),
	  });

	  if (response.ok) {
		alert("Trip created successfully！");
		navigate("/dashboard");
	  } else {
		const err = await response.json();
		alert("Create trip failed: " + JSON.stringify(err));
	  }
	};  

  return (
	<div className="p-4 sm:p-6 bg-white shadow-lg rounded-lg max-w-xl mx-auto w-full">
	  <div className="flex flex-col gap-4">
        <input
          type="text"
          placeholder="Trip Name"
          value={tripName}
          onChange={(e) => {
            setTripName(e.target.value);
            setTripNameEdited(true);
          }}
          className="border border-accent p-2 rounded"
		  disabled
        />
        <Select
          options={cityOptions}
          isMulti
          value={selectedCities}
          onChange={(selected) => setSelectedCities(selected || [])}
          onInputChange={(value) => setInputValue(value)}
          placeholder="Select a city..."
        />	
		<p className="text-sm text-gray-500 mt-1 ml-1">
		  Please enter the full place name(e.g.,“Taipei, London”)
		</p>	
		{inputValue.length > 0 && inputValue.length < 5 && (
		  <p className="text-sm text-red-500 mt-1 ml-1">
			Please enter a more complete place name for better results
		  </p>
		)}		
		<div className="relative">
		  <button
			onClick={() => setShowDatePicker(!showDatePicker)}
			className="w-full text-left border border-accent p-2 rounded bg-white"
		  >
			{startDate && endDate
			  ? `${startDate} ~ ${endDate}`
			  : "Select Date Range"}
		  </button>

		  {showDatePicker && (
			<div className="absolute z-10 mt-2 shadow-lg">
			  <DateRange
				editableDateInputs={true}
				onChange={(item) => {
				  setRange([item.selection]);
				  setStartDate(format(item.selection.startDate, "yyyy-MM-dd"));
				  setEndDate(format(item.selection.endDate, "yyyy-MM-dd"));
				}}
				moveRangeOnFirstSelection={false}
				ranges={range}
				onRangeFocusChange={(ranges) => {
				  // ranges === [0] 代表還在選擇 start
				  if (ranges[0] === 1) {
					// 已選完 endDate，自動收起
					setShowDatePicker(false);
				  }
				}}
			  />
			<div className="flex flex-col sm:flex-row sm:justify-between gap-2">
			  <button
				onClick={() => setShowDatePicker(false)}
				className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
			  >
				Done
			  </button>
			</div>			  
			</div>
		  )}
		</div>			
        <button
          onClick={createTrip}
          className="btn-full bg-primary text-white py-2 rounded hover:bg-orange-600 transition"
        >
          Create
        </button>
        <button
          onClick={() => navigate("/dashboard")}
          className="btn-full bg-primary text-white py-2 rounded hover:bg-orange-600 transition"
        >
          Back
        </button>
      </div>
    </div>
  );
};

export default CreateTrip;
